import React, { useContext, useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';
import './Auth.css';

const EmailVerificationSuccess = () => {
  const { user, firebaseUser } = useContext(UserContext);
  const [showContent, setShowContent] = useState(false);
  
  // Smooth entrance animation
  useEffect(() => {
    const timer = setTimeout(() => setShowContent(true), 100);
    return () => clearTimeout(timer);
  }, []);
  
  // If user is already logged in and verified, redirect to card generator
  if (user && !user.isGuest && user.emailVerified) {
    return <Navigate to="/card-generator" replace />;
  }
  
  return (
    <div className="verification-success-container">
      <div className={`verification-content ${showContent ? 'visible' : ''}`}>
        {/* Animated success icon */}
        <div className="success-icon-container">
          <div className="success-circle">
            <div className="success-checkmark">
              <div className="checkmark-stem"></div>
              <div className="checkmark-kick"></div>
            </div>
          </div>
        </div>
        
        {/* Main content */}
        <div className="success-text">
          <h1 className="success-title">Welcome to ARTIFEX</h1>
          <p className="success-subtitle">Your email has been verified successfully</p>
        </div>
        
        {/* Digital Card preview */}
        <div className="digital-card-preview">
          <div className="preview-card">
            <div className="card-shimmer"></div>
            <div className="card-content">
              <div className="card-logo">A</div>
              <div className="card-text">Your Digital Card</div>
              <div className="card-subtitle">Aesthetic passport ready for creation</div>
            </div>
          </div>
        </div>
        
        {/* Call to action */}
        <div className="cta-section">
          <Link to="/card-generator" className="create-card-button">
            <span className="button-text">Create Your Digital Card</span>
            <div className="button-shine"></div>
          </Link>
          
          <p className="cta-description">
            Design your aesthetic identity and unlock personalized content curation
          </p>
        </div>
        
        {/* Alternative actions */}
        <div className="alternative-actions">
          <Link to="/discover" className="skip-link">Skip for now, explore Artifex</Link>
        </div>
      </div>
      
      {/* Background decoration */}
      <div className="background-decoration">
        <div className="floating-element element-1"></div>
        <div className="floating-element element-2"></div>
        <div className="floating-element element-3"></div>
      </div>
    </div>
  );
};

export default EmailVerificationSuccess;